import styles from './styles.scss';
import Button from 'Components/Button';
import React from 'react';
import classNames from 'classnames/bind';
import { CarImage } from './CarImage';

const cx = classNames.bind(styles);

const Footer = ({
  model,
  goBack,
  goNext,
  transferData,
  loading,
  hasShadow,
  showSmallCarIn,
  showSmallCarOut,
  activeStep,
  lastStep,
  nextEnabled,
}) => (
  <div className={cx(styles.footer, hasShadow && styles.shadow)}>
    <div>
      {lastStep > 0 && (
        <Button
          onClick={goBack}
          icon="backward"
          className={styles.backButton}
          disabled={activeStep === 0}
        />
      )}
    </div>
    {showSmallCarIn && <CarImage carIn={model} carOut="" small />}
    {showSmallCarOut && <CarImage carIn="" carOut={model} small />}
    <div>
      {activeStep === lastStep ? (
        <Button
          onClick={transferData}
          label="Abschicken"
          small
          additionalProps={{ style: { height: '45px' } }}
          disabled={loading || !nextEnabled}
        />
      ) : (
        <Button
          onClick={goNext}
          label="Weiter"
          additionalProps={{ style: { height: '45px' } }}
          disabled={!nextEnabled}
          small
        />
      )}
    </div>
  </div>
);

export { Footer };
